import React, { useCallback } from 'react'
import type { Editor } from "@tiptap/react";

import linkIcon from "../../images/link.svg";
import listIcon from "../../images/list.svg";
import olIcon from "../../images/ol.svg";
import prevIcon from "../../images/prev.svg";
import nextIcon from "../../images/next.svg";

export type Props = {
  editor: Editor | null,
};

export const MenuBar: React.FC<Props> = ({ editor }) => {

  if (!editor) {
    return null
  }

  // リッチテキストエディタのリンク設定
  const setLink = useCallback(() => {
    const previousUrl = editor.getAttributes('link').href
    const url = window.prompt('URL', previousUrl)

    // URLが一度も登録されたことがなければ何もしない
    if (url === null) {
      return
    }
    // URLが空ならリンクを無効に
    if (url === '') {
      editor.chain().focus().extendMarkRange('link').unsetLink().run()
      return
    }
    // URLが入力されたらリンクを有効に
    try {
      editor.chain().focus().extendMarkRange('link').setLink({ href: url })
        .run()
    } catch (e: any) {
      alert(e.message)
    }
  }, [editor])

  return (
    <div className="control-group">
      <div className="button-group">
        <div className='d-flex me-3'>
          {/* 太字ボタン */}
          <button
            type='button'
            onClick={() => editor.chain().focus().toggleBold().run()}
            disabled={
              !editor.can()
              .chain()
              .focus()
              .toggleBold()
              .run()
            }
            className={editor.isActive('bold') ? 'is-active' : ''}
          >
            <strong>B</strong>
          </button>
          {/* 大見出しボタン */}
          <button
            type='button'
            onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()}
            className={editor.isActive('heading', { level: 2 }) ? 'is-active' : ''}
          >
            <strong>H2</strong>
          </button>
          {/* 小見出しボタン */}
          <button
            type='button'
            onClick={() => editor.chain().focus().toggleHeading({ level: 3 }).run()}
            className={editor.isActive('heading', { level: 3 }) ? 'is-active' : ''}
          >
            <strong>H3</strong>
          </button>
          {/* リンク */}
          <button type='button' onClick={setLink} className={editor.isActive('link') ? 'is-active' : ''}>
            <img src={linkIcon} />
          </button>
        </div>
        <div className='d-flex me-3'>
          {/* 箇条書きリスト */}
          <button
            type='button'
            onClick={() => editor.chain().focus().toggleBulletList().run()}
            className={editor.isActive('bulletList') ? 'is-active' : ''}
          >
            <img src={listIcon} />
          </button>
          {/* 番号付きリスト */}
          <button
            type='button'
            onClick={() => editor.chain().focus().toggleOrderedList().run()}
            className={editor.isActive('orderedList') ? 'is-active' : ''}
          >
            <img src={olIcon} />
          </button>
        </div>
        <div className='d-flex'>
          {/* 1つ前の状態に戻るボタン */}
          <button
            type='button'
            onClick={() => editor.chain().focus().undo().run()}
            disabled={
            !editor.can()
              .chain()
              .focus()
              .undo()
              .run()
            }
          >
            <img src={prevIcon} />
          </button>
          {/* 1つ先の状態に進むボタン */}
          <button
            type='button'
            onClick={() => editor.chain().focus().redo().run()}
            disabled={
            !editor.can()
              .chain()
              .focus()
              .redo()
              .run()
            }
          >
            <img src={nextIcon} />
          </button>
        </div>
      </div>
    </div>
  )
}
